export default {
  hello: {
    title: 'welcome to your vue.js app',
    languageBtn: 'change language',
    themeBtn: 'change theme'
  },
  nav: {
    title: 'dashboard',
    home: 'home',
    components: 'components',
    example: 'example',
    noAccess: 'noAccess',
    user: 'user'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/en.js